var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fillable-cell-component-container",style:(`
    height: ${_vm.height || 32}px;
    width: ${ _vm.width || 128}px;
    justify-content: ${_vm.flex_align_horizontal || 'center'};
    align-items: ${_vm.flex_align_vertical || 'center'};
    ${_vm.is_no_shrink ? 'flex-shrink:0;' : ''}
  `)},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }